import React, { useContext, useEffect, useState } from "react";

import supabase from "../supabase/supabaseClient";
import estilo from "./styles/Inicio.module.css";

import TarjetasVideo from "../components/TarjetasVideo";

import { DataContext } from "../context/DataContext";
import MetaDecorator from "../utils/MetaDecorator";

function Inicio() {
  const { activarSubir, setActivarSubir, activarBuscador } =
    useContext(DataContext);

  function subir() {
    setActivarSubir(!activarSubir);
  }

  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    const fecthUsuarios = async () => {
      const { data, error } = await supabase.from("usuarios").select();

      if (data) {
        // console.log(data);
        setUsuarios(data.sort(() => Math.random() - 0.5));
      }
      if (error) {
        console.log(error);
      }
    };
    fecthUsuarios();
  }, []);

  let listaMenu = [
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
        </svg>
      ),
      nombre: "Principal",
    },
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7z"></path>
        </svg>
      ),
      nombre: "Shorts",
    },
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="M4 8H2v12a2 2 0 0 0 2 2h12v-2H4z"></path>
          <path d="M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-9 12V6l7 4z"></path>
        </svg>
      ),
      nombre: "Biblioteca",
    },
  ];

  let listaExplorar = [
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="M16.5 8c0 1.5-.5 3.5-2.9 4.3.7-1.7.8-3.4.3-5-.7-2.1-3-3.7-4.6-4.6-.4-.3-1.1.1-1 .7 0 1.1-.3 2.7-2 4.4C4.1 10 3 12.3 3 14.5 3 17.4 5 21 9 21c-4-4-1-7.5-1-7.5.8 5.9 5 7.5 7 7.5 1.7 0 5-1.2 5-6.4 0-3.1-1.3-5.5-2.4-6.9-.3-.5-1-.2-1.1.3"></path>
        </svg>
      ),
      nombre: "Tendencia",
    },
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="M6 18.573c2.206 0 4-1.794 4-4V4.428L19 7.7v7.43a3.953 3.953 0 0 0-2-.557c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4V7a.998.998 0 0 0-.658-.939l-11-4A.999.999 0 0 0 8 3v8.13a3.953 3.953 0 0 0-2-.557c-2.206 0-4 1.794-4 4s1.794 4 4 4z"></path>
        </svg>
      ),
      nombre: "Musica",
    },
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="M21.986 9.74a3.193 3.193 0 0 0-.008-.088A5.003 5.003 0 0 0 17 5H7a4.97 4.97 0 0 0-4.987 4.737c-.01.079-.013.161-.013.253v6.51c0 .925.373 1.828 1.022 2.476A3.524 3.524 0 0 0 5.5 20c1.8 0 2.504-1 3.5-3 .146-.292.992-2 3-2 1.996 0 2.853 1.707 3 2 1.004 2 1.7 3 3.5 3 .925 0 1.828-.373 2.476-1.022A3.524 3.524 0 0 0 22 16.5V10c0-.095-.004-.18-.014-.26zM7 12.031a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 12.031zm10-5a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-2 4a1 1 0 1 1 0-2 1 1 0 1 1 0 2zm2 2a1 1 0 1 1 0-2 1 1 0 1 1 0 2zm2-2a1 1 0 1 1 0-2 1 1 0 1 1 0 2z"></path>
        </svg>
      ),
      nombre: "Videojuegos",
    },
    ,
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-1 4v2h-5V7h5zm-5 4h5v2h-5v-2zM4 19V5h7v14H4z"></path>
        </svg>
      ),
      nombre: "Noticias",
    },
    ,
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="M6 5v14h3v-6h6v6h3V5h-3v6H9V5zM3 15a1 1 0 0 0 1 1h1V8H4a1 1 0 0 0-1 1v2H2v2h1v2zm18-6a1 1 0 0 0-1-1h-1v8h1a1 1 0 0 0 1-1v-2h1v-2h-1V9z"></path>
        </svg>
      ),
      nombre: "Deportes",
    },
    ,
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="M9 20h6v2H9zm7.906-6.288C17.936 12.506 19 11.259 19 9c0-3.859-3.141-7-7-7S5 5.141 5 9c0 2.285 1.067 3.528 2.101 4.73.358.418.729.851 1.084 1.349.144.206.38.996.591 1.921h-.792v2h8.032v-2h-.79c.213-.927.45-1.719.593-1.925.352-.503.726-.94 1.087-1.363z"></path>
        </svg>
      ),
      nombre: "Aprendizaje",
    },
  ];

  let masYoutube = [
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="M21.593 7.203a2.506 2.506 0 0 0-1.762-1.766C18.265 5.007 12 5 12 5s-6.264-.007-7.831.404a2.56 2.56 0 0 0-1.766 1.778c-.413 1.566-.417 4.814-.417 4.814s-.004 3.264.406 4.814c.23.857.905 1.534 1.763 1.765 1.582.43 7.83.437 7.83.437s6.265.007 7.831-.403a2.515 2.515 0 0 0 1.767-1.763c.414-1.565.417-4.812.417-4.812s.02-3.265-.407-4.831zM9.996 15.005l.005-6 5.207 3.005-5.212 2.995z"></path>
        </svg>
      ),
      nombre: "Youtube Premium",
    },
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="M21.593 7.203a2.506 2.506 0 0 0-1.762-1.766C18.265 5.007 12 5 12 5s-6.264-.007-7.831.404a2.56 2.56 0 0 0-1.766 1.778c-.413 1.566-.417 4.814-.417 4.814s-.004 3.264.406 4.814c.23.857.905 1.534 1.763 1.765 1.582.43 7.83.437 7.83.437s6.265.007 7.831-.403a2.515 2.515 0 0 0 1.767-1.763c.414-1.565.417-4.812.417-4.812s.02-3.265-.407-4.831zM9.996 15.005l.005-6 5.207 3.005-5.212 2.995z"></path>
        </svg>
      ),
      nombre: "Youtube Music",
    },
    {
      svg: (
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path d="M21.593 7.203a2.506 2.506 0 0 0-1.762-1.766C18.265 5.007 12 5 12 5s-6.264-.007-7.831.404a2.56 2.56 0 0 0-1.766 1.778c-.413 1.566-.417 4.814-.417 4.814s-.004 3.264.406 4.814c.23.857.905 1.534 1.763 1.765 1.582.43 7.83.437 7.83.437s6.265.007 7.831-.403a2.515 2.515 0 0 0 1.767-1.763c.414-1.565.417-4.812.417-4.812s.02-3.265-.407-4.831zM9.996 15.005l.005-6 5.207 3.005-5.212 2.995z"></path>
        </svg>
      ),
      nombre: "Youtube Kids",
    },
  ];

  return (
    <div className={estilo.inicio} onClick={() => activarBuscador(false)}>
      <MetaDecorator
        titulo={"ClonTube"}
        subtitulo={"ClonTube"}
        descripcion={
          "Este clon de YouTube es una plataforma de videos que ofrece una experiencia similar a la del original, permitiendo a los usuarios buscar, ver y compartir videos. Además, cuenta con una variedad de características útiles, como la capacidad de comentar y calificar los videos, y también recomendaciones personalizadas basadas en el historial de visualización del usuario. Con una interfaz amigable y una amplia selección de contenido, este clon de YouTube es una opción perfecta para aquellos que buscan una alternativa a la plataforma original."
        }
      ></MetaDecorator>

      <div className={estilo.lista_menu}>
        <div className={estilo.lista}>
          {listaMenu.map((e, i) => (
            <div key={i} className={estilo.contenido}>
              {e.svg}
              <p>{e.nombre}</p>
            </div>
          ))}
        </div>

        <div className={estilo.titulo_lista_subir}>
          <p>
            Puedes Subir un video sin necesidad de registrarte, solo comparte tu
            video.
          </p>
          <div className={estilo.subir} onClick={subir}>
            <svg width="28" height="28" viewBox="0 0 24 24">
              <path d="M18 7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3.333L22 17V7l-4 3.333V7zm-4 6h-3v3H9v-3H6v-2h3V8h2v3h3v2z"></path>
            </svg>
            <p>Subir</p>
          </div>
        </div>

        <div className={estilo.titulo_lista}>
          <h3>Explorar</h3>
        </div>

        <div className={estilo.explorar}>
          {listaExplorar.map((e, i) => (
            <div key={i} className={estilo.contenido}>
              {e.svg}
              <p>{e.nombre}</p>
            </div>
          ))}
        </div>

        <div className={estilo.titulo_lista}>
          <h3>Más de Youtube</h3>
        </div>

        <div className={estilo.explorar}>
          {masYoutube.map((e, i) => (
            <div key={i} className={`${estilo.contenido} ${estilo.mas}`}>
              {e.svg}
              <p>{e.nombre}</p>
            </div>
          ))}
        </div>

        <div className={estilo.derechos}>
          <p>
            Acerca de Prensa Derechos de autor Comunicarte con nosotros
            Creadores Anunciar Desarrolladores Condiciones PrivacidadPolíticas y
            seguridadCómo funciona YouTube Prueba funciones nuevas.
          </p>
          <p>© 2023 Google LLC</p>
        </div>
      </div>

      <div className={estilo.tarjeta}>
        {usuarios.map((e, i) => (
          <TarjetasVideo key={i} e={e} variante={"inicio"}></TarjetasVideo>
        ))}
      </div>
    </div>
  );
}

export default Inicio;
